import { render, staticRenderFns } from "./ChatMergeForward.vue?vue&type=template&id=af63612e&scoped=true"
import script from "./ChatMergeForward.vue?vue&type=script&lang=js"
export * from "./ChatMergeForward.vue?vue&type=script&lang=js"
import style0 from "./ChatMergeForward.vue?vue&type=style&index=0&id=af63612e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af63612e",
  null
  
)

export default component.exports